import { render, staticRenderFns } from "./ListCart.vue?vue&type=template&id=1070f3ee&"
import script from "./ListCart.vue?vue&type=script&lang=js&"
export * from "./ListCart.vue?vue&type=script&lang=js&"
import style0 from "./ListCart.vue?vue&type=style&index=0&id=1070f3ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports